module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Update-c5d8a9db114f59b3e0323916649d4142.svg";